import React from "react";
import { useTranslation } from 'react-i18next';

import GameType from "../data/GameType";

const DrawCountSelector = (props) => {
    const {t} = useTranslation();
    const maxDrawCount = props.gameType === GameType.KENO || props.gameType === GameType.JOKKER ? 14 : 10;
    return (
        <div className='flexCenter margin1 drawCountSelector'>
          {  <div>
                {t('texts.drawCount')}
            </div>
           }
           <div className='flexCenter'>
                <button disabled={props.drawCount === 1} onClick={() => props.setDrawCount(props.drawCount - 1)} className='round darkBlue drawCount marginRight1'>-</button>
                <span className='fs125 drawCount--number'>{props.drawCount}</span>
                <button disabled={props.drawCount === maxDrawCount} onClick={() => props.setDrawCount(props.drawCount + 1)} className='round darkBlue drawCount marginLeft1'>+</button>
            </div>
        </div>
    );
};

export default DrawCountSelector;